/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcription_ImportingInputs */



/**
* | output |
* | --- |
* | "Importing transcript..." |
*
* @param {Transcription_ImportingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcription_importing = /** @type {((inputs?: Transcription_ImportingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcription_ImportingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importing transcript...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Importing transcript...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importing transcript...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Importing transcript...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importing transcript...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Importing transcript...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Importing transcript...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Importing transcript...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importing transcript...")
	return /** @type {LocalizedString} */ ("Importing transcript...")
});